<div class="flex-container" fxLayout="row" fxLayoutGap="20px" fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutAlign.xs="start" *ngIf="success">
<div style="width:90%">
    <mat-card>
        <mat-card-content>
            <div *ngIf="!!incident">   
                <table>
                        <tr>
                            <th style="width: 20%">Id</th> <td>{{incident.FriendlyId}}</td>
                        </tr>
                        <tr>
                            <th  style="width: 20%">Classification</th> <td>{{incident.Classification}}</td>
                        </tr>
                        <tr>
                            <th  style="width: 20%">Title</th> <td>{{incident.Title}}</td>
                        </tr>
                        <tr>
                            <th style="width: 20%">Impact</th> <td>{{incident.ImpactDescription}}</td>
                        </tr>
                        <tr>
                            <th style="width: 20%">Feature</th> <td>{{incident.FeatureGroupName}}</td>
                        </tr>
                        <tr>
                            <th style="width: 20%">Workload</th> 
                            <td>{{getWorkloadNames(incident.AffectedWorkload)}}</td>
                        </tr>
                        <tr>
                            <th  style="width: 20%">Start Date</th> 
                            <td>{{incident.StartDate| date:'yyyy/MM/dd HH:mm'}}</td>
                        </tr>
                        <tr>
                            <th  style="width: 20%">Last Updated Time</th> 
                            <td>{{incident.LastUpdatedTime| date:'yyyy/MM/dd HH:mm'}}</td>
                        </tr>
                        <tr>
                            <th style="width: 20%">End Date</th> 
                            <td>{{incident.EndDate| date:'yyyy/MM/dd HH:mm'}}</td>
                        </tr>
                        <tr>
                            <th  style="width: 20%">Messages</th> 
                            <td>
                                    <div style="margin-top: 30px;margin-bottom: 30px">
                                            <div style="cursor: pointer;" (click)="ToggleMessages()">
                                                  <i *ngIf="openmessages==false" class="fa fa-caret-right" style="margin-right:10px;color: grey"></i>
                                                  <i *ngIf="openmessages==true" class="fa fa-caret-down" style="margin-right:10px;color: grey"></i>
                                                  <span matBadge="{{incident.Posts.length}}" matBadgeOverlap="false"><span>Messages</span></span>
                                            </div>
                                            <div *ngIf="openmessages==true" style="padding:18px;border: 1px solid #ccc;border-radius: 4px;background-color: #f5f5f5">
                                                  <div *ngIf="!!incident.Posts && incident.Posts.length>0" >
                                                        <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th style="width: 80%">
                                                                            Message
                                                                        </th>
                                                                        <th style="width: 20%">
                                                                            Created Time
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr *ngFor="let item of incident.Posts">
                                                                        <td>{{ item.Message}}</td>
                                                                        <td>{{ item.CreatedTime| date:'yyyy/MM/dd HH:mm' }}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                  </div>                  
                                            </div>
                                      </div>
                            </td>
                        </tr>
                </table>
            </div>

            <div style="margin-top: 30px;margin-bottom: 30px">
                    <div style="cursor: pointer;margin-bottom: 20px" (click)="onToggle()">
                          <i *ngIf="open==false" class="fa fa-caret-right" style="margin-right:10px;color: grey"></i>
                          <i *ngIf="open==true" class="fa fa-caret-down" style="margin-right:10px;color: grey"></i>
                          <span>Incidents in your tenant</span>
                    </div>
                    <div *ngIf="open==true" style="padding:18px;border: 1px solid #ccc;border-radius: 4px;background-color: #f5f5f5">
                        <div *ngIf='calledForIncidents && (!incidents || incidents.length==0)'>
                            There are no incidents at the moment.
                        </div>
                        <div *ngIf="!!incidents && incidents.length>0">
                            <table class="table table-bordered table-striped table-hover" style="word-break:break-word" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
                                    <thead>
                                        <tr>
                                            <th style="width: 5%">
                                                Id
                                            </th>
                                            <th style="width: 5%">
                                                Classification
                                            </th>
                                            <th style="width: 25%">
                                                Title
                                            </th>
                                            <th style="width: 20%">
                                                Impact
                                            </th>
                                            <th style="width: 10%">
                                                Feature
                                            </th>
                                            <th style="width: 10%">
                                                Workload
                                            </th>
                                            <th style="width: 7%">
                                                Start Time
                                            </th>
                                            <th style="width: 7%">
                                                Last Updated Time
                                            </th>
                                            <th style="width: 6%">
                                                EndTime
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of filteredList">
                                            <td><a [routerLink]="['/incidents', item.Id]">{{item.FriendlyId}}</a></td>
                                            <td>
                                                <span *ngIf='item.ClassificationIcon=="advisory"' style="color:orange;font-size: large;">&#9888;</span>
                                                <span *ngIf='item.ClassificationIcon=="incident"' style="color:red;font-size: medium;"><i class="fa fa-exclamation-triangle"></i></span>
                                                <span *ngIf='item.ClassificationIcon=="investigation"'  style="color:blue;font-size: large;">?</span>
                                                <span *ngIf='item.ClassificationIcon=="close"'  style="color:green;font-size: large;">&#9745;</span>
                                            </td>
                                            <td>{{item.Title}}</td>
                                            <td>{{item.ImpactDescription}}</td>
                                            <td>{{item.FeatureGroupName}}</td>
                                            <td>{{getWorkloadNames(item.AffectedWorkload)}}</td>
                                            <td>{{item.StartDate| date:'yyyy/MM/dd HH:mm'}}</td>
                                            <td>{{item.LastUpdatedTime| date:'yyyy/MM/dd HH:mm'}}</td>
                                            <td>{{item.EndDate| date:'yyyy/MM/dd HH:mm'}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>                  
                    </div>
            </div>
        </mat-card-content>
    </mat-card>
</div> 
       